var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "consumption" } },
    [
      _c("div", { staticClass: "content consumption-title" }, [
        _c("h2", [_vm._v(_vm._s(_vm.currentTab.label))]),
      ]),
      _vm.currentType.name === "consumption"
        ? _c("div", { staticClass: "content" }, [
            _c("h3", [_vm._v("统计信息")]),
            _c("div", { staticClass: "statistical-information" }, [
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v("￥" + _vm._s(_vm.customerOrderStatities.totalAmount)),
                ]),
                _c("p", [_vm._v("消费金额")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.customerOrderStatities.orderCount)),
                ]),
                _c("p", [_vm._v("订单数量")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v("￥" + _vm._s(_vm.customerOrderStatities.avgAmount)),
                ]),
                _c("p", [_vm._v("客单价")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.customerOrderStatities.aftermarketCount)),
                ]),
                _c("p", [_vm._v("售后次数")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.customerOrderStatities.refundCount)),
                ]),
                _c("p", [_vm._v("退货记录")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [
                  _vm._v(
                    "￥" + _vm._s(_vm.customerOrderStatities.refundAmount)
                  ),
                ]),
                _c("p", [_vm._v("退款金额")]),
              ]),
              _c("div", { staticClass: "statistical-item" }, [
                _c("p", [_vm._v(_vm._s(_vm.customerOrderStatities.orderNum))]),
                _c("p", [_vm._v("下单次数")]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "h3",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [
              _vm._v(" 列表数据 "),
              _vm.currentType.name === "consumption"
                ? _c(
                    "el-button",
                    {
                      staticClass: "add-order",
                      attrs: { type: "primary" },
                      on: { click: _vm.goAddOrder },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
              _vm.currentType.name === "followUp"
                ? _c(
                    "el-button",
                    {
                      staticClass: "add-order",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.followUpBtn("新增跟进记录")
                        },
                      },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.currentTab.name === "allocation"
            ? _c(
                "el-radio-group",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  on: { input: _vm.changeRadio },
                  model: {
                    value: _vm.radio1,
                    callback: function ($$v) {
                      _vm.radio1 = $$v
                    },
                    expression: "radio1",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "分配排序" } }),
                  _c("el-radio-button", { attrs: { label: "开单排序" } }),
                ],
                1
              )
            : _vm._e(),
          _c("lb-table", {
            attrs: {
              column: _vm.tableColumn,
              data: _vm.list,
              pagination: _vm.list.length > 0 ? true : false,
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "新增跟进记录",
            visible: _vm.drawer,
            direction: _vm.direction,
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "followUp",
              attrs: { model: _vm.followUp, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "跟进人:",
                    prop: "customerName",
                    "label-width": "110px",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.followUp.customerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.followUp, "customerName", $$v)
                      },
                      expression: "followUp.customerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "接听状态:",
                    prop: "receiveState",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.answerStatus },
                      model: {
                        value: _vm.followUp.receiveState,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "receiveState", $$v)
                        },
                        expression: "followUp.receiveState",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("无")]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("接通"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("未接通"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  ref: "condition",
                  attrs: {
                    label: "接听状况:",
                    "label-width": "110px",
                    prop: _vm.receiveDetailsState,
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择接听状况",
                        clearable: "",
                        disabled: _vm.answerState,
                        "default-first-option": true,
                      },
                      model: {
                        value: _vm.followUp.receiveDetails,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "receiveDetails", $$v)
                        },
                        expression: "followUp.receiveDetails",
                      },
                    },
                    _vm._l(_vm.answerStateDate.list, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "微信添加状态:",
                    prop: "wxFencing",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.wxAddState },
                      model: {
                        value: _vm.followUp.wxFencing,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "wxFencing", $$v)
                        },
                        expression: "followUp.wxFencing",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "3" } }, [
                        _vm._v("已添加"),
                      ]),
                      _c("el-radio", { attrs: { label: "4" } }, [
                        _vm._v("未添加"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.followUp.wxFencing === "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户微信号", "label-width": "110px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        model: {
                          value: _vm.followUp.wechatNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "wechatNo", $$v)
                          },
                          expression: "followUp.wechatNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.followUp.wxFencing === "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户微信号2", "label-width": "110px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        model: {
                          value: _vm.followUp.wechatNo2,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "wechatNo2", $$v)
                          },
                          expression: "followUp.wechatNo2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.followUp.wxFencing === "3"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "跟进客服微信号",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: 20,
                          oninput:
                            "if (value.length > 20) value = value.slice(0, 20);",
                        },
                        model: {
                          value: _vm.followUp.serviceWechatNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.followUp, "serviceWechatNo", $$v)
                          },
                          expression: "followUp.serviceWechatNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "微信状况:",
                    prop: "wxDetails",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择微信状况",
                        clearable: "",
                        "default-first-option": true,
                      },
                      model: {
                        value: _vm.followUp.wxDetails,
                        callback: function ($$v) {
                          _vm.$set(_vm.followUp, "wxDetails", $$v)
                        },
                        expression: "followUp.wxDetails",
                      },
                    },
                    _vm._l(_vm.wxAddStateData.list, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", "label-width": "110px" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.followUp.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.followUp, "comment", $$v)
                      },
                      expression: "followUp.comment",
                    },
                  }),
                ],
                1
              ),
              _vm.parArray.indexOf("template_send") != -1
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleCss" }, [
                        _vm._v(" 发送短信 "),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "发送短信:",
                            "label-width": "110px",
                            prop: "sendMessageFlag",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handlerSendRadio },
                              model: {
                                value: _vm.followUp.sendMessageFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.followUp, "sendMessageFlag", $$v)
                                },
                                expression: "followUp.sendMessageFlag",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("否"),
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("是"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.followUp.sendMessageFlag == "1"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "模板:",
                                prop: _vm.templateIdProp,
                                "label-width": "110px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择模板",
                                  },
                                  on: { change: _vm.selectTemplate },
                                  model: {
                                    value: _vm.followUp.templateId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.followUp, "templateId", $$v)
                                    },
                                    expression: "followUp.templateId",
                                  },
                                },
                                _vm._l(_vm.templateOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                              _vm.templateCenter
                                ? _c("div", { staticClass: "templateDiv" }, [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.templateCenter)),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.followUp.paramList.length != 0
                        ? _c(
                            "div",
                            _vm._l(_vm.customerMessage, function (item, index) {
                              return _c(
                                "el-form-item",
                                {
                                  key: index,
                                  attrs: {
                                    "label-width": "110px",
                                    label: "参数",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        " 参数" + _vm._s(index + 1) + "： "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: function ($event) {
                                          return _vm.messageModel(
                                            index,
                                            _vm.followUp.paramList[index]
                                              .paramType
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.followUp.paramList[index]
                                            .paramType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.followUp.paramList[index],
                                            "paramType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "followUp.paramList[index].paramType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v("客户信息")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "2" } },
                                        [_vm._v("自定义信息")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.followUp.paramList[index].paramType == "2"
                                    ? _c("el-input", {
                                        ref: "saveTagInput",
                                        refInFor: true,
                                        staticClass: "input-new-tag",
                                        attrs: {
                                          placeholder: "请输入客户信息",
                                        },
                                        model: {
                                          value:
                                            _vm.followUp.paramList[index]
                                              .paramContent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.followUp.paramList[index],
                                              "paramContent",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "followUp.paramList[index].paramContent",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.followUp.paramList[index].paramType == "1"
                                    ? _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请选择客户信息",
                                          },
                                          model: {
                                            value:
                                              _vm.followUp.paramList[index]
                                                .paramContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.followUp.paramList[index],
                                                "paramContent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "followUp.paramList[index].paramContent",
                                          },
                                        },
                                        _vm._l(
                                          _vm.dictionaries
                                            .message_customer_user_info,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.dictName,
                                                value: item.dictId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.followUp.sendMessageFlag == "1"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "模板签名:",
                                prop: _vm.signNameProp,
                                "label-width": "110px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择模板签名",
                                  },
                                  model: {
                                    value: _vm.followUp.signName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.followUp, "signName", $$v)
                                    },
                                    expression: "followUp.signName",
                                  },
                                },
                                _vm._l(
                                  _vm.dictionaries.message_sign_type,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.dictName,
                                        value: item.dictId,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", "label-width": "110px" } },
                        [
                          _vm.followUp.sendMessageFlag == "1"
                            ? _c(
                                "el-checkbox",
                                {
                                  attrs: { "false-label": 0, "true-label": 1 },
                                  on: { change: _vm.handlerCheckbox },
                                  model: {
                                    value: _vm.followUp.defFlag,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.followUp, "defFlag", $$v)
                                    },
                                    expression: "followUp.defFlag",
                                  },
                                },
                                [_vm._v("设为默认 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticStyle: { float: "right", "padding-bottom": "20px" } },
                [
                  _c(
                    "el-button",
                    { staticClass: "cancel", on: { click: _vm.handlerQuxiao } },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "affirm",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.subFollowUp("followUp")
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }